// Generated by Melange

import * as Caml_option from "melange.js/caml_option.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function Logo(Props) {
  let className = Props.className;
  let tmp = {
    children: JsxRuntime.jsx("path", {
      d: "m282.775 7.445-.154-.147-.002-.002c-.252-.242-.43-.413-.525-.52-10.541-11.9-20.185-6.263-35.444 2.654-4.92 2.874-10.422 6.09-16.727 9.17-7.639 3.73-16.946 5.331-27.155 7.088-23.498 4.044-51.775 8.91-75.485 42.456-6.778 9.59-5.671 31.79 6.805 38.847 78.256 44.274 86.917 65.557 99.805 115.98-11.025-13.805-25.219-25.102-41.189-32.783-6.719-3.232-14.742-7.09-25.213-13.092-85.49-49.005-124.83-37.799-131.004-36.04h-.002c-.337.096-.575.164-.716.192-15.65 3.113-17.749 8.581-18.498 14.162-3.403 25.335 3.402 16.89-3.403 50.108-25.518 63.057-17.58 131.012 38.561 114.29 17.012-5.067 31.821-16.379 50.292-24.444l.005-.003h.001l.011-.005c13.604-5.94 27.38-11.955 40.99-18.336 19.827-9.296 44.774-5.697 65.117-.469-29.908 10.659-49.994 21.609-87.233 43.257-73.588 61.306-61.97 95.886-64.08 104.72-5.103 21.382 64.08 38.284 79.426 65.764 5.436 4.643 11.221 9.585 17.544 14.746 9.715 7.93 28.974 8.573 45.933 4.504 13.687-3.284 24.434-24.318 24.16-33.757-.255-8.801.041-19.117.349-29.875.464-16.164 2.956-10.122-.349-47.843 2.827-34.146 7.766-49.988 22.599-72.339 9.602 44.996.018 28.478 32.203 90.918 27.769 53.873 102.502 93.459 110.441 77.132 20.982-27.588 37.379-45.062 44.977-52.055 17.49-16.098 38.536-35.469 40.017-76.424.424-11.708-2.768-26.911-36.226-33.104-76.555 2.252-89.14-7.745-129.697-38.656 40.667 0 115.31.371 127.429-9.763s105.803-34.118 65.78-75.443c-14.176-14.638-12.475-61.931-47.634-79.384-14.176-25.115-20.61-21.064-30.622-24.773-6.6-2.445-28.457-6.547-36.435 7.934-51.461 93.408-47.26 94.258-91.853 114.568l13.335-39.739 8.343-49.545c0-96.984-29.385-125.08-34.477-129.95m-2.124 234.313-13.09-23.538-20.383 17.704-26.593 5.087 10.661 24.716-3.346 26.682 26.972-2.428 24.525 11.404 6.009-26.218 18.502-19.633z"
    }),
    "aria-label": "Violette",
    height: "24",
    width: "24",
    fill: "currentColor",
    fillRule: "evenodd",
    viewBox: "0 0 512 512"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return JsxRuntime.jsx("svg", tmp);
}

const make = Logo;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
